module.exports = __webpack_public_path__ + "img/User.04737678.svg";